import { render, staticRenderFns } from "./EmployeeLedger.vue?vue&type=template&id=626e6878&scoped=true"
import script from "./EmployeeLedger.vue?vue&type=script&lang=js"
export * from "./EmployeeLedger.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLedger.vue?vue&type=style&index=0&id=626e6878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626e6878",
  null
  
)

export default component.exports